import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "user",
  initialState: null,
  reducers: {
    setUser: (state, action) => action.payload,
    logOutUser: () => null,
  },
});

// Action creators are generated for each case reducer function
export const { setUser,logOutUser } = userSlice.actions;

export default userSlice.reducer;


export const selectUser=(state)=>state.user